var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ce-button"},[_c('a',{staticClass:"btn btn-circle",on:{"click":function($event){return _vm.goToPage('/' + _vm.objectdata.url)}}},[_c('span',[_vm._v(_vm._s(_vm.objectdata.linkTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }